import React from "react"

import Seo from "../components/seo"
import HeroInner from "../components/heroinner"
import GetInTouchForm from "../components/getintouch_form"
// import iFastLogo from "../static/images/iFast--logo.png"

export default function ContactUs() {
  const heroTitle = "Contact Us"
  const heroImage = "/images/slider/ContactUs--Banner.jpg"
  const heroMobileImage = "/images/slider/mobile/ContactUs--Banner.jpg"
  return (
    <>
      <Seo title={heroTitle} />
      <HeroInner heroTitle={heroTitle} heroImage={heroImage} heroMobileImage={heroMobileImage} />
      <section class="c-section c-section-sm">
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-6 col-md-6">
              <div class="sec-title light">
                <h1 class="h2 h2-sm">Get in Touch</h1>
                <p class="text">
                  If you have any questions, would like to know more about us, or if you would like
                  to book an appointment, please enter your details and we’ll be in touch to discuss
                  your needs.
                </p>
                <p>
                  Alternatively, you can connect with us directly and speak to a member of the team
                  for direct onboarding as a PMS investor.
                </p>
              </div>

              <GetInTouchForm />
            </div>

            <div class="col-12 col-lg-6 col-md-6 sm:mmt-6">
              <div class="innerpage--content innerpage--content-sm mt-0 pb-2">
                <h2 class="h3 h3-sm">Contact Details</h2>
                <ul class="address">
                  <li>
                    <span class="small--title">Email:</span>{" "}
                    <a href="mailto:kunal.bhatia@apricuswealth.in">kunal.bhatia@apricuswealth.in</a>
                  </li>
                  <li>
                    <span class="small--title">Phone:</span>{" "}
                    <a href="tel:+919810302008">+91 98103 02008</a>
                  </li>
                  <li>
                    <span class="small--title">Mobile:</span>{" "}
                    <a href="tel:+919811004140">+91 98110 04140</a>
                  </li>
                  <li>
                    <span class="small--title">Office:</span> Flat no. 1105, 11th Floor, 1106
                    Skipper House, 22, Fire Brigade Lane, Barakhamba, Connaught Place, New Delhi -
                    110001
                  </li>
                </ul>

                {/* <img
                  src={iFastLogo}
                  alt="iFAST Corporation Ltd"
                  class="iFast--logo img-thumbnail mb-2"
                />

                <p class="mb-2">
                  Kunal Bhatia of Apricus Wealth Advisors is an Investment Adviser of iFAST Global
                  Markets, the investment advisory division of iFAST Financial India. iFAST is a
                  corporate SEBI Registered Investment Adviser. Details of iFast Financial India:
                </p> */}

                <p class="mb-4">
                  <strong>Apricus Wealth Investment Managers LLP</strong>
                  <br />
                  Type of Registration: Non-Individual
                  <br />
                  Registration number of the RIA: INA0000017657 (Validity: Perpetual)
                  <br />
                  Registration number of the PMS: INP000009302
                </p>

                <p class="mb-4">
                  <strong>Complete address with telephone no:</strong>
                  <br />
                  Apricus Wealth Investment Managers LLP
                  <br />
                  Flat no. 1105, 11th Floor, 1106 Skipper House, 22, Fire Brigade Lane, Barakhamba,
                  Connaught Place
                  <br />
                  New Delhi - 110001
                  <br />
                  (+91 98103 02008)
                </p>

                <div className="row">
                  <div className="col-12 col-lg-6 col-md-6 sm:mmt-6">
                    <p>
                      <strong>Contact Details of the Principal Officer of the RIA:</strong>
                      <br />
                      Kunal Bhatia
                      <br />
                      <a href="tel:+919811004140">+91 98110 04140</a>
                      <br />
                      <a href="mailto:kunal.bhatia@apricuswealth.in">
                        kunal.bhatia@apricuswealth.in
                      </a>
                    </p>
                  </div>
                  <div className="col-12 col-lg-6 col-md-6 sm:mmt-6">
                    <p>
                      <strong>Contact Details of the Principal Officer of the PMS:</strong>
                      <br />
                      Vikrant Gupta
                      <br />
                      <a href="tel:+919810302008">+91 98103 02008</a>
                      <br />
                      <a href="mailto:vikrant@apricuswealth.in">vikrant@apricuswealth.in</a>
                    </p>
                  </div>
                </div>

                <p class="mb-4 mt-3">
                  <strong>Contact Details of the Investor Relations Officer:</strong>
                  <br />
                  Parineeta Haldhar
                  <br />
                  <a href="tel:+918799707048">+91 87997 07048</a>
                  <br />
                  <a href="mailto:support@apricuswealth.in">support@apricuswealth.in</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
